import { SubscriptionPlanType } from '@workalizer/db';
export var subscriptionData = function (input) {
    return {
        totalUsers: 100,
        enabledUsers: 10,
        disabledUsers: 0,
        plans: {
            free: {
                id: 1,
                type: SubscriptionPlanType.FREE,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                maxUsers: 1,
                docAlertsPerUser: 1,
                isAiInsights: false,
                price: 0,
                pricePerUser: '0.00',
                isTimeline: false
            },
            premium: {
                id: 2,
                type: SubscriptionPlanType.PREMIUM,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                maxUsers: 100,
                docAlertsPerUser: 100,
                isAiInsights: true,
                price: 299,
                pricePerUser: '2.99',
                isTimeline: true
            }
        }
    };
};
